var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportDownloadWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.606934 0.484344H28.1983C28.1983 9.68148 28.1983 18.8786 28.1983 28.0758H0.606934V0.484344Z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0154 0.4841H58.6068C58.6068 9.68124 58.6068 18.8784 58.6068 28.0755H31.017C31.017 18.8784 31.017 9.68124 31.017 0.4841H31.0154Z",
    fill: "#80BA01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.606934 30.891C9.80407 30.891 19.0012 30.891 28.1983 30.891C28.1983 40.0881 28.1983 49.2847 28.1983 58.4807H0.606934V30.891Z",
    fill: "#02A4EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.017 30.8944C40.2131 30.8944 49.4097 30.8944 58.6068 30.8944V58.4841H31.0154C31.0154 49.287 31.0154 40.0904 31.0154 30.8944H31.017Z",
    fill: "#FFB902"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportDownloadWindows);
export default __webpack_public_path__ + "static/media/support_download_windows.d92e32d3db48e693041bb779a39e9fe4.svg";
export { ForwardRef as ReactComponent };